'use client';
// ============================================================
// DESIGN EDITOR STYLES GUARD
// This component is a safety net — it reads the saved CSS from
// the design-editor-applied.css file via the API and injects it
// as an inline <style> tag so Design Editor changes survive even
// if the CSS import in layout.tsx or tailwind.css is ever lost.
// ============================================================
import { useEffect } from 'react';

const STYLE_TAG_ID = 'design-editor-guard-styles';
const STORAGE_KEY = 'DesignEditor_AppliedCSS_v1';

export default function DesignEditorStylesGuard() {
  useEffect(() => {
    // Try to restore from sessionStorage cache first (instant, no network)
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) {
      injectStyles(cached);
    }

    // Always fetch fresh CSS from the file to stay up-to-date
    fetch('/api/design-editor/styles', { cache: 'no-store' })
      .then(res => (res.ok ? res.text() : null))
      .then(css => {
        if (css && css.trim()) {
          sessionStorage.setItem(STORAGE_KEY, css);
          injectStyles(css);
        }
      })
      .catch(() => {
        // Silently fail — the @import in tailwind.css is the primary mechanism
      });
  }, []);

  return null;
}

function injectStyles(css: string) {
  // Remove any existing guard style tag
  const existing = document.getElementById(STYLE_TAG_ID);
  if (existing) existing.remove();

  const style = document.createElement('style');
  style.id = STYLE_TAG_ID;
  style.setAttribute('data-design-editor', 'guard');
  style.textContent = css;
  document.head.appendChild(style);
}
